import initGroupDetails from '../shared/group_details';

document.addEventListener('DOMContentLoaded', () => {
  initGroupDetails('details');
});
